import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import Axios from 'axios';
import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-material.css"; // Optional Theme applied to the Data Grid
import '../style/Dashboard.scss'
import backArrow from "../props/backArrow.png"
import * as XLSX from 'xlsx';
import { useLocation } from "react-router-dom";
import FormInputTextField from "../components/ui/FormInputTextField";
import Button from "../components/ui/Button";

const Dashboard = () => {
    document.title="Dashboard Zento"
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const navigate = useNavigate();
    const batchId = searchParams.get('batchId');
    let postURL = "/api/data/range";
    let instanceURL = "/batch/instance/";
    if (process.env.NODE_ENV === "development")
    {
        postURL="http://localhost:4000/api/data/range"
        instanceURL="http://localhost:4000/batch/instance/"
    }
    const today = new Date();
    const [rowDBData, setRowDBData] = useState([]);
    const [startDate, setStartDate] = useState(new Date(today.getFullYear(), today.getMonth(), 2).toISOString().split('T')[0]);
    const [endDate, setEndDate] = useState(new Date(today.getFullYear(), today.getMonth() + 1, 1).toISOString().split('T')[0]);
    const [colDefs, setColDefs] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [pimInstance, setPimInstance] = useState("")


    function mergeLanguages(array) {
        return array.map(row => {
            if (row.inputLanguage && row.outputLanguage) {
                row.inputLanguage += ' - ' + row.outputLanguage;
                delete row.outputLanguage
            }

            return row;
        });
    }

    const queryDBdata = async (url = postURL, params = {}) => {
        try {
            const databaseData = await Axios({
                method: "POST",
                url,
                data: params
            });
            if (databaseData.data.length === 0) {
                setErrorMessage('Aucune donnée trouvée pour les dates sélectionnées');
                setRowDBData([])
                return;
            }
            var sortedTranslations = databaseData.data.sort((a, b) => b.translations - a.translations);
            sortedTranslations = mergeLanguages(sortedTranslations);
            setRowDBData(sortedTranslations);
            let columns = Object.keys(sortedTranslations[0]).map((col, index) => ({
                field: col,
                pinned: index === 0 ? 'left' : null,
                width: index === 0 ? "275px" : null
            }));
            setColDefs(columns);
        } catch {
            console.log("Error in fetching database data");
            setErrorMessage('Error in fetching database data. Contact the administrator.');
        }
    };
    

    function formatDateWithoutYear(date) {
        date = new Date(date);
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const formattedMonth = month.toString().padStart(2, '0');
        const formattedDay = day.toString().padStart(2, '0');

        return `${formattedMonth}-${formattedDay}`;
    }
    
    const downloadExcel = () => {
        const ws = XLSX.utils.json_to_sheet(rowDBData);
        const wb = XLSX.utils.book_new();
        const defaultWidth = 20;
        const columnWidths = rowDBData.length ? Object.keys(rowDBData[0]).map(() => ({ wch: defaultWidth })) : [];
        
        ws['!cols'] = columnWidths;
        XLSX.utils.book_append_sheet(wb, ws, "Translations");
        XLSX.write(wb, { bookType: 'xlsx', type: 'buffer' });
        XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
        XLSX.writeFile(wb, 'Translations_' + formatDateWithoutYear(startDate) + '_to_' + formatDateWithoutYear(endDate) + '.xlsx');
    };

    useEffect(() => {
        const fetchInstance = async () => {
            if (batchId) {
                try {
                    console.log(`${instanceURL}${batchId}`)
                    const res = await Axios.get(`${instanceURL}${batchId}`);
                    if (res.data && res.data.quableInstance) {
                        setPimInstance(res.data.quableInstance);
                    }
                } catch (error) {
                    console.error("Error fetching instance:", error);
                    setErrorMessage("Could not verify Batch Instance.");
                }
            }
        };
        fetchInstance();
    }, [batchId]);

    useEffect(()=>{
        if (batchId && !pimInstance) {
            return; 
        }

        queryDBdata(postURL, { startDate, endDate, pimInstance });
    }, [pimInstance])

    const handleFetchData = () => {
        if (startDate && endDate) {
            setErrorMessage('');
            queryDBdata(postURL, { startDate, endDate, pimInstance });
        }
    };

    return(
        <div>
            <div className='dashboardTitle'>
                <img src="Favicon-zento.png" alt="Zento Logo" style={{ position: 'absolute', top: '10px', left: '10px' }} />
                <div className='inputDatesDiv'>
                    <FormInputTextField
                        name="startDate"
                        label="Date de début : "
                        type="date"
                        onChange={e => setStartDate(e.target.value)}
                        value={startDate}
                    />
                    {/* <div style={{'padding-left': '40px'}}>
                        <h4>Start Date: </h4>
                    </div>
                    <input
                        type="date"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        placeholder="Start Date"
                    /> */}
                    <FormInputTextField
                        name="endDate"
                        label="Date de fin : "
                        type="date"
                        onChange={(e) => setEndDate(e.target.value)}
                        value={endDate}
                    />
                    {/* <div>
                        <h4>End Date: </h4>
                    </div>
                    <input
                        type="date"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        placeholder="End Date"
                    /> */}
                    <div>
                        <Button
                            className="btn btn--primary inputDatesDiv--btn"
                            onClick={handleFetchData}
                            textButton="Mise à jour"
                            disabled={new Date(startDate) > new Date(endDate)}
                        ></Button>
                    </div>
                    {/* <button
                        className={new Date(startDate) > new Date(endDate) ? 'greyButton' : 'blueButton'}
                        onClick={handleFetchData}
                        style={{
                            margin: '20px',
                        }}
                        disabled={new Date(startDate) > new Date(endDate)}
                    >
                        Update
                    </button> */}
                    {/* <button
                        className='blueButton'
                        onClick={() => downloadExcel(rowDBData)}
                        style={{
                            margin: '20px',
                            cursor: "pointer"
                        }}>
                        Download
                    </button> */}
                    <div>
                        <Button
                            className="btn btn--hyperlink inputDatesDiv--btn"
                            onClick={() => downloadExcel(rowDBData)}
                            textButton="Téléchargement →"
                            style={{ marginTop: '37px' }}
                        ></Button>
                    </div>
                    <div>
                        {{ errorMessage } && <div style={
                            {
                                color: '#D32F2F',
                                marginTop: '37px',
                            }
                        }>{errorMessage}</div>}
                    </div>
                </div>
                <div className="dashboardBackButton">
                    <Button
                        className="btn btn--hyperlink--dark"
                        onClick={() => navigate(-1)}
                        textButton="Retour →"
                    ></Button>
                    {/* <button
                        className='blueButton'
                        onClick={() => navigate(-1)}
                        style={{
                            margin: '20px',
                            cursor: "pointer"
                        }}
                    >
                        Back to Translator
                    </button> */}
                </div>
            </div>
            <div
                className="ag-theme-material"
                style={{height: 500}}
            >
                <AgGridReact
                    style={{width: '80%', height: '100%'}}
                    rowData={rowDBData}
                    columnDefs={colDefs}
                    rowSelection='single'
                    columnSize="flex"
                    suppressDragLeaveHidesColumns='True'
                    domLayout='autoHeight'
                />
            </div>
        </div>
    )
}
export default Dashboard;